/*
Kollar om det finns en css-class i en hero eller annan modul som säger att det ska vara en meny med vit text. I så fall så lägger denna till css-class "dark" i header.
*/

const headerElement = document.querySelector(".matane-header");
const checkDarkHeader = document.querySelector(".matane-header-dark");

if (checkDarkHeader) {
	headerElement.classList.add("dark");
}

/*
Togglar aktiva css-klasser för featured menu-knappen och filtret som dyker upp när man klickar på featured menu-knappen.
*/

const featuredMenu = document.querySelector(".matane-featured-menu");
const featuredMenuOutside = document.querySelector(
	".matane-featured-menu-outside"
);
const openButton = document.querySelector(".matane-featured-menu-open-button");
const closeButton = document.querySelector(
	".matane-featured-menu-close-button"
);

openButton.addEventListener("click", () => {
	featuredMenu.classList.remove("matane-featured-menu-inactive");
	featuredMenu.classList.add("matane-featured-menu-active");
	featuredMenuOutside.classList.remove("matane-featured-menu-outside-inactive");
	featuredMenuOutside.classList.add("matane-featured-menu-outside-active");
});

closeButton.addEventListener("click", () => {
	featuredMenu.classList.add("matane-featured-menu-inactive");
	featuredMenu.classList.remove("matane-featured-menu-active");
	featuredMenuOutside.classList.add("matane-featured-menu-outside-inactive");
	featuredMenuOutside.classList.remove("matane-featured-menu-outside-active");
});

featuredMenuOutside.addEventListener("click", () => {
	featuredMenu.classList.add("matane-featured-menu-inactive");
	featuredMenu.classList.remove("matane-featured-menu-active");
	featuredMenuOutside.classList.add("matane-featured-menu-outside-inactive");
	featuredMenuOutside.classList.remove("matane-featured-menu-outside-active");
});

document.addEventListener("keydown", (e) => {
	if (featuredMenu.classList.contains("matane-featured-menu-active")) {
		if (e.key === "Escape") {
			featuredMenu.classList.add("matane-featured-menu-inactive");
			featuredMenu.classList.remove("matane-featured-menu-active");
			featuredMenuOutside.classList.add(
				"matane-featured-menu-outside-inactive"
			);
			featuredMenuOutside.classList.remove(
				"matane-featured-menu-outside-active"
			);
		}
	}
});

// Initialize variables to keep track of scroll position and header state
let lastScrollTop = 0;
const header = document.querySelector(".matane-header");

// Listen for scroll events
window.addEventListener("scroll", () => {
	// Get current scroll position
	const scrollTop = window.scrollY;

	// Check if we scrolled down
	if (scrollTop > lastScrollTop && scrollTop > 200) {
		// If yes, hide the header
		header.classList.add("matane-header-hidden");
	}
	// Check if we scrolled up at least 15px
	else if (lastScrollTop - scrollTop > 10) {
		// If yes, show the header
		header.classList.remove("matane-header-hidden");
	}

	// Update last scroll position
	lastScrollTop = scrollTop;
});
// Get all dropdown buttons
const dropdownButtons = document.querySelectorAll(
	".matane-featured-menu-dropdown-button"
);

dropdownButtons.forEach((button) => {
	button.addEventListener("click", function (event) {
		// Prevent default behavior (so it doesn't navigate)
		event.preventDefault();

		// Hide other dropdowns
		document
			.querySelectorAll(
				".matane-featured-menu-dropdown.matane-featured-menu-dropdown-active"
			)
			.forEach((dropdown) => {
				if (dropdown !== this.nextElementSibling) {
					// exclude the current dropdown
					dropdown.classList.remove("matane-featured-menu-dropdown-active");
				}
			});

		// Toggle visibility of the current dropdown
		const currentDropdown = this.nextElementSibling;
		currentDropdown.classList.toggle("matane-featured-menu-dropdown-active");
	});
});
